import { Link } from "react-router-dom";
import CompanyListTable, {
  formatCreated,
} from "../../components/AdminDashboard/CompanyListTable";

const COLUMNS = [
  {
    header: "Company Name",
    render: (row) => (
      <Link
        to={`/admin-dashboard/project-managers/${row?._id}`}
        style={{ cursor: "pointer", textDecoration: "underline" }}
      >
        {row?.name}
      </Link>
    ),
  },
  { header: "Name", render: (row) => row?.fullName },
  {
    header: "Industry",
    render: (row) =>
      Array.isArray(row?.industry) ? row.industry.join(", ") : row?.industry,
  },
  { header: "Created", preWrap: true, render: (row) => formatCreated(row?.createdAt) },
  { header: "Location", render: (row) => row?.city },
];

const ProjectManager = () => (
  <CompanyListTable
    type="Project Manager"
    title="Project Manager"
    emptyLabel="project managers"
    columns={COLUMNS}
  />
);

export default ProjectManager;
